export default "https://cdn-web.disco.co/slack-email-preview-background-455b70b3d3b3417f8a7a536c270dea0f.png";